import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import { useUserPreferencesListQueryOptions } from "./use-user-preferences-list-query";

type Params = {
  index: number;
  value: string;
};

export const useEditUserPreferencesMutation = () => {
  const fetch = useAuthFetch();
  const queryClient = useQueryClient();
  const preferencesOptions = useUserPreferencesListQueryOptions();
  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/user-preferences/${params.index}`,
        {
          method: "PATCH",
          body: JSON.stringify({
            value: params.value,
          }),
        }
      );

      const data: Response = await response.json();

      return data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: preferencesOptions.queryKey,
      });
    },
  });
};
